module.exports = __webpack_public_path__ + "static/m_how_it_works_life_art@2x-8c3b8eef761540fd74d726b0446c6977.png";